module.exports = __webpack_public_path__ + "SP_SPT3-Window-d585d1f5c5d39c03bbb92a7b4b49ba30.png";